// extracted by mini-css-extract-plugin
export default {"background":"styles_background__7n6Cr","logo":"styles_logo__gqX+M","box":"styles_box__PVbUg","title":"styles_title__XCu-D","text":"styles_text__HJGu8"};